import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export const STATI_MESE = {
  aperto: { label: "Aperto", cls: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  inviato: { label: "Inviato", cls: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  approvato: { label: "Approvato", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  fatturato: { label: "Fatturato", cls: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-600" },
};

export function StatoBadge({ stato, testid }) {
  const s = STATI_MESE[stato] || STATI_MESE.aperto;
  return <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold ${s.cls}`} data-testid={testid}><span className={`h-2 w-2 rounded-full ${s.dot}`} />{s.label}</span>;
}

export function StatoMeseSelect({ commessaId, anno, mese, stato, disabled }) {
  const qc = useQueryClient();
  const mut = useMutation({
    mutationFn: async (v) => (await api.put(`/prestazioni/${commessaId}/stato`, { anno: Number(anno), mese: Number(mese), stato: v })).data,
    onSuccess: (r) => { toast.success(`Mese segnato come "${STATI_MESE[r.stato].label}"`); ["prest-riepilogo", "commesse", "prest-dashboard", "prest-stati"].forEach((k) => qc.invalidateQueries({ queryKey: [k] })); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  const s = STATI_MESE[stato] || STATI_MESE.aperto;
  return (
    <Select value={stato || "aperto"} onValueChange={(v) => mut.mutate(v)} disabled={disabled || mut.isPending}>
      <SelectTrigger className={`w-40 h-9 font-semibold border ${s.cls}`} data-testid="prest-stato-mese"><SelectValue /></SelectTrigger>
      <SelectContent>{Object.entries(STATI_MESE).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`prest-stato-opt-${k}`}>{v.label}</SelectItem>)}</SelectContent>
    </Select>
  );
}
